'use client';

import type { ColumnDef } from '@benzinga/table';
import type { InsidersTradeFiling } from '@benzinga/insider-trades-manager';

import {
  formatFilingDate,
  formatPriceCell,
  getInsiderNamesValue,
  getTradeStatusValue,
  renderFilingDate,
  renderInsiderNames,
  renderRemainingShares,
  renderTicker,
  renderTradeDates,
  renderTradeStatus,
  renderTradedShares,
  renderTradedValue,
} from './sharedCells';

export function getRecentInsiderColumnDefs(): ColumnDef<InsidersTradeFiling>[] {
  return [
    { field: 'company_ticker', headerName: 'Ticker', width: 140, cellRenderer: renderTicker },
    { field: 'traded_shares', headerName: 'Qty.', width: 110, cellRenderer: renderTradedShares },
    { field: 'traded_share_price', headerName: 'Price', width: 90, valueFormatter: formatPriceCell },
    { field: 'traded_value', headerName: 'Size ($)', width: 100, cellRenderer: renderTradedValue },
    {
      field: 'last_filing_date',
      headerName: 'Filing Date',
      width: 115,
      valueFormatter: formatFilingDate,
      cellRenderer: renderFilingDate,
    },
    {
      field: 'trade_status',
      headerName: 'Type',
      width: 115,
      valueGetter: getTradeStatusValue,
      cellRenderer: renderTradeStatus,
    },
    { field: 'remaining_shares', headerName: 'Own', width: 100, cellRenderer: renderRemainingShares },
    {
      field: 'insider_names',
      headerName: 'Insider name & title',
      width: 180,
      valueGetter: getInsiderNamesValue,
      cellRenderer: renderInsiderNames,
    },
    { field: 'trade_dates', headerName: 'Trade Dates', width: 140, cellRenderer: renderTradeDates },
  ];
}
